<template>
  <div class="tags-view" v-if="visitedViews.length">
    <el-scrollbar class="tags-scroll">
      <router-link
        v-for="tag in visitedViews"
        :key="tag.path"
        :to="{ path: tag.path, query: tag.query }"
        class="tags-item"
        :class="{ active: isActive(tag) }"
        @click.middle.native="!isAffix(tag) && closeTag(tag)"
      >
        <span>{{ tag.title }}</span>
        <i
          v-if="!isAffix(tag)"
          class="el-icon-close"
          @click.prevent.stop="closeTag(tag)"
        />
      </router-link>
    </el-scrollbar>
    <el-dropdown class="tags-actions" trigger="click" @command="handleCommand">
      <span class="tags-more"><i class="el-icon-arrow-down"></i></span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="closeOthers">关闭其他</el-dropdown-item>
        <el-dropdown-item command="closeAll">关闭全部</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TagsView',
  computed: {
    ...mapState('tagsView', ['visitedViews']),
  },
  watch: {
    $route: {
      handler(route) {
        this.$store.dispatch('tagsView/addView', route)
      },
      immediate: true,
    },
  },
  methods: {
    isActive(tag) {
      return tag.path === this.$route.path
    },
    isAffix() {
      return false
    },
    closeTag(tag) {
      this.$store.dispatch('tagsView/delView', tag).then((views) => {
        if (this.isActive(tag) && views.length) {
          const last = views[views.length - 1]
          this.$router.push({ path: last.path, query: last.query })
        } else if (this.isActive(tag)) {
          this.$router.push(sessionStorage.getItem('loginPage') || '/login')
        }
      })
    },
    handleCommand(cmd) {
      const current = {
        path: this.$route.path,
        query: this.$route.query,
        title: this.$route.meta?.title,
      }
      if (cmd === 'closeOthers') {
        this.$store.commit('tagsView/DEL_OTHERS_VIEWS', current)
      }
      if (cmd === 'closeAll') {
        this.$store.commit('tagsView/DEL_ALL_VIEWS')
        const loginPage = sessionStorage.getItem('loginPage') || '/login'
        this.$router.push(loginPage)
      }
    },
  },
}
</script>

<style scoped lang="less">
.tags-view {
  height: 34px;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  padding: 0 8px;
  box-sizing: border-box;
}
.tags-scroll {
  flex: 1;
  ::v-deep .el-scrollbar__wrap {
    overflow-y: hidden;
  }
}
.tags-item {
  display: inline-flex;
  align-items: center;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  margin-right: 6px;
  font-size: 12px;
  color: #495060;
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  text-decoration: none;
  white-space: nowrap;
  &.active {
    color: #409eff;
    border-color: #409eff;
    background: #ecf5ff;
  }
  .el-icon-close {
    margin-left: 6px;
    border-radius: 50%;
    font-size: 12px;
    &:hover {
      background: #c0c4cc;
      color: #fff;
    }
  }
}
.tags-actions {
  flex-shrink: 0;
  margin-left: 4px;
}
.tags-more {
  display: inline-block;
  width: 28px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
  cursor: pointer;
  color: #666;
}
</style>
